import { createSelector } from "@reduxjs/toolkit";
import selectConfigMap from "./configMapSelector";
import { getFlatEntityListFromConfigMap } from "../utils/entityUtils";

const flatEntityListSelector = createSelector(selectConfigMap, (configMap) =>
  getFlatEntityListFromConfigMap(configMap),
);

export default flatEntityListSelector;
